import { useTheme } from '@emotion/react';
import { UmbracoTypes } from '~/lib/data-contract';
import { UmbracoImage } from '~/shared/components/Image';
import { Link } from '~/shared/components/Link';
import { Video } from '~/shared/components/Video';
import { queries } from '~/theme';
import { useModule } from '../../hooks/useModule';
import { useModuleTheme } from '../../hooks/useModuleTheme';
import { ModuleContainer } from '../../shared/ModuleContainer';
import { StyledM70 } from './styled';

export type M70MediaProps = UmbracoTypes.IM70MediaModule;

export const M70Media = ({ caption, image, video, link, ...rest }: M70MediaProps) => {
    const { index } = useModule();
    const { sizes } = useTheme();
    const { textColor } = useModuleTheme(rest);

    const mediaType = video ? 'video' : 'image';
    const isImage = mediaType === 'image';

    if (!video?.src && !image?.src) {
        return null;
    }

    const ImageWrapper = link ? Link : 'div';

    return (
        <ModuleContainer hasGutter {...rest}>
            <StyledM70 textColor={textColor} as={isImage ? 'figure' : 'div'} mediaType={mediaType}>
                {mediaType === 'image' && image ? (
                    <ImageWrapper href={link?.url} {...link}>
                        <UmbracoImage
                            src={image.src}
                            alt={image.alt ?? caption ?? ''}
                            fill
                            sizes={`${queries.contentMax} ${sizes.contentMaxWidth}px, 100vw`}
                            priority={index < 2}
                            focalPoint={image.focalPoint}
                        />
                    </ImageWrapper>
                ) : null}
                {mediaType === 'video' && video ? (
                    <Video
                        controls={false}
                        src={video.src}
                        loop={video.loop}
                        playing={video.autoPlay}
                        posterSrc={image?.src}
                    />
                ) : null}
            </StyledM70>
        </ModuleContainer>
    );
};
